import React, { useState, useEffect, useContext } from "react";
import moment from "moment";
import { Link } from "react-router-dom";
import http from "../services/http";
import { toast } from "react-toastify";
import UserContext from "../context/userContext";

const ManageReports = () => {
  const [user] = useContext(UserContext);

  const [shared, setShared] = useState([]);

  useEffect(() => {
    document.title = "FTR - Manage Reports";
    return () => {
      document.title = "FTR";
    };
  }, []);

  useEffect(() => {
    async function getShared() {
        const { data } = await http.get(`/Reports/shared`);
        setShared(data);
    }
    if (user) {
      getShared();
    }
  }, [user]);

  async function handleArchiveClick(report, type) {
    setShared(shared.filter((s) => s.ID !== report.ID));

    try {
      await http.delete(`/report/${report.ID}`);
      toast.success("Report Archived");
    } catch (ex) {
      if (ex.response) {
        toast.error(ex.response.data);
      }
    }
  }

  return (
    <div className="col mt-4">
      {user.MAINTAIN_REPORTS && (
        <React.Fragment>
          <div className="row">
            <div className="col-auto">
              <h3>Reports</h3>
            </div>
          </div>
          <div className="row">
            <div className="col">
              <table className="table table-sm">
                <thead>
                  <tr>
                    <th>Name</th>
                    <th>Category</th>
                    <th>Last Updated</th>
                    <th>Updated By</th>
                    <th></th>
                    <th></th>
                  </tr>
                </thead>
                <tbody>
                  {shared.map((report) => (
                    <tr key={report.ID}>
                      <td>
                        <Link to={`/report/manage/${report.ID}`}>
                          {report.REPORT_NAME}
                        </Link>
                      </td>
                      <td>{report.CATEGORY}</td>
                      <td>{moment.utc(report.LAST_UPDATED_DTS).calendar()}</td>
                      <td>{report.LAST_UPDATED_BY}</td>
                      <td>
                        <button
                          className="btn btn-danger"
                          onClick={() => handleArchiveClick(report, "Shared")}
                        >
                          <i className="fas fa-trash"></i>
                        </button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </React.Fragment>
      )}
    </div>
  );
};

export default ManageReports;
